import { render, staticRenderFns } from "./RoleInfo.vue?vue&type=template&id=272dad0c"
import script from "./RoleInfo.vue?vue&type=script&lang=js"
export * from "./RoleInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports